import React from "react";
import { PiImage } from "react-icons/pi";

function DefaultImage({ imgClass, imgSize }) {
  return (
    <div
      className={`w-full h-40 flex items-center duration-500 justify-center rounded-3xl text-gray-500 bg-gray-100 ${imgClass}`}
    >
      <PiImage size={imgSize ? imgSize : 46} />
    </div>
  );
}

export default DefaultImage;
